module.exports = "data:image/webp;base64,UklGRiYBAABXRUJQVlA4IBoBAACwBgCdASoeAB4APpE8nEkloyMhKAqosBIJaQATjPGv9ArW0B/v8ZdTNNXdOa17HB5xrXleAamsncMIZAfoIAD++54Zc+eEnenm79Rn+oC2ztIxCjaT2qEhJrzHtpU8DJ5T216QYGPveQq8JDm9Tmo2pFnJk3L5wmb788UUcrbFvHz20O4+r9qZspzcbeuGbXigAvoxHRalykBdkh/1fHH37QPt1pcRK3yTzns4C6QusXaigPBV/jpOiabJ5pRQFb0bk91Q4KgdpE5f6oWnBMqZCN+k/RAKGutiEBU1CFePs9s+qkX4XcxjUro92OPp/1dL7wpBTFHsUXah1i/hyCw+XG3Vd40HYnq6t6sftGSPt88tCBv3ZIXoQAA="


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/black_sw2.webp
// module id = fZHL
// module chunks = 14